import { render, staticRenderFns } from "./RepairProcessIndex.vue?vue&type=template&id=74e58f36&scoped=true&"
import script from "./RepairProcessIndex.vue?vue&type=script&lang=js&"
export * from "./RepairProcessIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e58f36",
  null
  
)

export default component.exports